import Model from '~/models/base/Model';

/**
 * class representing owners
 * @extends Model
 * @author rn
 */
export default class Owner extends Model {
    static _url = `${super._url}/incidents/owners/`;

    constructor(id = null, options) {
        super(id, options);
    }
}
